<template>
	<nk-page commercialAccess="Salary" policyClaims="Salary_SalaryItem_Management" tabindex="101" startup :buttons="[footerButtons.refresh]">
		<template #badges>
			<nk-badge system="salary">
				<nk-badge-item type="system" modelValue="salary"></nk-badge-item>
				<nk-badge-item type="system" modelValue="salary" :title="$t('forms.SalaryItems')"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="d-flex flex-column h-100">
			<!-- <div v-if="!settings.isSelectionMode" class="nk-card p-3 mb-4">
				<div class="d-inline-flex">
					<div class="bgPrimary-light-fade d-flex p-1 ml-3 " style="border-radius: 3px">
						<span class="primary-light px-2 ">وضعیت :</span>
						<span class="text-dark text-extra-bold">استفاده نشده در فرمول</span>
						<i class="fa-solid fa-xmark d-flex px-3 cursor-pointer" style="align-items: center"></i>
					</div>
					<nk-button :options="filterButtonOptions"></nk-button>
				</div>
			</div> -->
			<div class="nk-card h-100">
				<ag-grid :options="tableOption" :data="items" v-model="selectedRows" @preSelectedRowData="(data: SalaryItem) => selectedRow = data" @row_db-clicked="(row: any) => showItem(row)" tabindex="105" startup></ag-grid>
			</div>
		</div>
	</nk-page>
</template>

<script lang="ts">
	import $sc from '@/plugins/shortcut.collection'
	import _ from 'lodash'
	import BooleanView from '@/components/form/boolean-label.vue'
	import Tag from '@/components/general/nk-tag.vue'
	import { defineComponent } from 'vue'
	import { post } from '@/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { SalaryItemActionTypes, SalaryItemFillTypes, SalaryItemTypes } from '@/enums/salary'
	import { ConvSalaryItem, dataTypes, entryTypes, itemTypes, SalaryItem, operationTypes, SelectedDataEntry, SelectedDataType, SelectedFunctionType, SelectedItemType } from '@/classes/salary/salary-item'
	import modifyItem from '@/views/salary/salary-item/salary-item-modify.vue'
	import { isEmpty } from '@/statics/validators'
	import { Guid, IResponse, IResponseList } from '~/interfaces/base'
	import dialog from '@/plugins/nikan-dialog-plugin'
	import { TYPE } from 'vue-toastification'
	import SalaryItemContractsUsage from '@/components/form/salary/salary-item/salary-item-contracts-usage.vue'
	import SalaryItemDependency from '@/components/form/salary/salary-item/salary-item-dependency.vue'
	import SystemSalaryItemList from './system-salary-item-list.vue'

	export default defineComponent({
		name: "salary-items",
		modal: {
			size: 'lg',
			stateUID: 'salary-items-selectors',
			helpTag: 'SalaryItems'
		},
		props: {
			options: Object,
		},
		data() {
			return {
				isModal: false,
				bottomButtons: {},
				selectedRows: [] as SalaryItem[],
				topButtons: {
					saveButton: {
						title: this.$t('rowStates.changed'),
						shortcut: $sc.find('edit'),
						isPrimary: false,
						disabled: true,
						icon: 'save',
						handle: () => {
							this.showItem()
						},
						policyClaims: {
							or: ['Salary_SalaryItem_Add', 'Salary_SalaryItem_Edit'],
						},
						selfButton: true,
						// items: [],
					},
					deleteButton: {
						title: this.$t('delete'),
						shortcut: $sc.find('delete', 'document'),
						icon: 'trash',
						disabled: true,
						handle: this.showDeleteDialog
						,
						policyClaims: 'Salary_SalaryItem_Delete',
					},
					addButton: {
						title: this.$t('new'),
						shortcut: $sc.find('new'),
						icon: 'plus',
						isPrimary: false,
						disabled: false,
						handle: () => {
							this.showItem(null, true)
						},
						policyClaims: 'Salary_SalaryItem_Add',
					},
					editButton: {
						title: this.$t('edit'),
						shortcut: $sc.find('edit'),
						icon: 'edit',
						isPrimary: false,
						handle: () => {
							this.showItem()
						},
						policyClaims: 'Salary_SalaryItem_Edit',
					},
					printButton: {
						type: 'print',
						navMenuKey: 'Accounting',
						form: 'Document',
						getDataSources: this.print_dataSources,
						disabled: true,
					},
					selectButton: {
						title: this.$t('select'),
						shortcut: $sc.find('enter-only'),
						icon: 'check',
						isPrimary: false,
						disabled: false,
						handle: this.handlerBtnSelect,
						// policyClaims: 'Salary_SalaryItem_List',
					},
					systemSalaryItemButton: {
						title: this.$t('salary.salary-item.copyFromSystemItems'),
						shortcut: $sc.find('edit'),
						isPrimary: false,
						disabled: false,
						icon: 'save',
						handle: () => {
							this.showSystemSalaryItems()
						}
					},
					operationsButton: {
						title: this.$t('salary.salary-item.operations'),
						icon: 'user-hard-hat',
						isPrimary: false,
						selfButton: false,
						items: [
							{
								title: this.$t('salary.salary-item.contract-usage'),
								isPrimary: false,
								handle: () => {
									this.showUsageModal(true)
								},
							},
							{
								title: this.$t('salary.salary-item.contract-usage-all-periods'),
								isPrimary: false,
								handle: () => {
									this.showUsageModal(false)
								},
							},
							{
								title: this.$t('salary.salary-item.dependency'),
								isPrimary: false,
								handle: () => {
									this.showDependencyModal()
								},
							}
						]
					},
				},
				footerButtons: {
					refresh: {
						title: this.$t('trs.chq.oper.refresh'),
						icon: 'sync',
						handle: () => {
							this.getData()
						},
					}
				},
				filterButtonOptions: {
					isPrimary: true,
					title: 'فیلتر پیشرفته',
					icon: 'fa-regular fa-filter',
				},
				itemTypes: itemTypes as SelectedItemType[],
				entryTypes: entryTypes as SelectedDataEntry[],
				operationTypes: operationTypes as SelectedFunctionType[],
				dataTypes: dataTypes as SelectedDataType[],
				items: [] as ConvSalaryItem[],
				selectedRow: [] as any,
				settings: {
					isSelectionMode: false,
					filterByTypes: [] as SalaryItemTypes[],
					filterByfillTypes: [] as SalaryItemFillTypes[],
					filterByActionTypes: [] as SalaryItemActionTypes[],
					excludeByIds: [] as Guid[],
					excludeDisabledItems: true,
					isMultiSelect: true,
				},
				defaultCellClass: 'px-3 nk-border-radius ',
				tableOption: {
					id: this.$options.name,
					checkboxesEnabled: false,
					pagination: false,
					groupIncludeTotalFooter: false,
					enterToSelect: true,
					cellSelectionAggReport: false,
					rowSelection: {
						mode: 'singleRow'
					},
					sideBar: 'none',
					focusAndSelect: {
						allowFocus: true
					},
					columnDefs: [
						{
							field: 'rowNumber',
							headerName: this.$t('row-number'),
							width: 80,
							maxWidth: 120,
						},
						{
							field: 'code',
							headerName: this.$t('salary.code'),
							filter: true,
							width: 60
						},
						{
							field: 'name',
							headerName: this.$t('salary.item-name'),
							filter: 'agTextColumnFilter',
						},
						{
							field: 'displayName',
							headerName: this.$t('salary.display-name'),
							filter: 'agTextColumnFilter',
						},
						{
							field: 'orderIndex',
							headerName: this.$t('salary.item.orderIndex'),
							contentType: 'number',
						},
						{
							field: 'includeTax',
							headerName: this.$t('salary.include-tax'),
							contentType: 'enum',
							filter: true,
							cellClass: ' text-center',
							valueFormatter: (data: any) => typeof data.value === 'boolean' && this.$t(`boolean-yes-no.${data.value}`),
							cellRenderer: BooleanView,
							cellRendererParams: (data: any) => {
								return {
									options: {
										useColors: true,
										modelValue: data.value
									},
								}
							},
							width: 75
						},
						{
							field: 'includeInsurance',
							headerName: this.$t('salary.include-insurance'),
							contentType: 'enum',
							filter: true,
							cellClass: ' text-center',
							valueFormatter: (data: any) => typeof data.value === 'boolean' && this.$t(`boolean-yes-no.${data.value}`),
							cellRenderer: BooleanView,
							cellRendererParams: (data: any) => {
								return {
									options: {
										useColors: true,
										modelValue: data.value
									},
								}
							},
							width: 75
						},
						{
							field: 'fillType',
							headerName: this.$t('salary.entry-method'),
							contentType: 'enum',
							filter: true,
							cellClass: 'text-center',
							valueFormatter: (params: any) => {
								return (this.entryTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: Tag,
							cellRendererParams: (params: any) => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.entryTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.entryTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
							width: 120
						},
						{
							field: 'actionType',
							headerName: this.$t('salary.operation-type'),
							contentType: 'enum',
							filter: true,
							cellClass: 'text-center',
							valueFormatter: (params: any) => {
								return (this.operationTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: Tag,
							cellRendererParams: (params: any) => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.operationTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.operationTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
							width: 120
						},
						{
							field: 'type',
							headerName: this.$t('salary.choice-type'),
							contentType: 'enum',
							filter: true,
							cellClass: 'text-center',
							valueFormatter: (params: any) => {
								return (this.itemTypes as any).find((x: any) => x.id === params.value)?.name
							},
							cellRenderer: Tag,
							cellRendererParams: (params: any) => {
								return {
									options: {
										class: this.defaultCellClass + ' ' + (this.itemTypes as any).find((x: any) => x.id === params.value)?.class,
									},
									value: (this.itemTypes as any).find((x: any) => x.id === params.value)?.name
								}
							},
							width: 120
						},
						{
							field: 'isActive',
							headerName: this.$t('salary.active'),
							filter: true,
							contentType: 'enum',
							cellClass: ' text-center',
							valueFormatter: (data: any) => typeof data.value === 'boolean' && this.$t(`boolean-yes-no.${data.value}`),
							cellRenderer: BooleanView,
							cellRendererParams: (data: any) => {
								return {
									options: {
										useColors: true,
										modelValue: data.value
									},
								}
							},
							width: 75
						}
					]
				} as any,
			}
		},
		watch: {
			selectedRow: {
				deep: true,
				handler(val) {
					if (val) {
						this.topButtons.saveButton.disabled = false
						this.topButtons.deleteButton.disabled = false
					} else {
						this.topButtons.saveButton.disabled = true
						this.topButtons.deleteButton.disabled = true
					}
				}
			}
		},
		created() {
			this.settings = _.merge({}, this.settings, this.options)
			this.changeFormModeToSelection()
		},
		mounted() {
			let pageButtons
			this.isModal = this.grandParentType() === 'modal'
			if (this.settings.isSelectionMode || this.isModal)
				pageButtons = [this.topButtons.selectButton]
			else
				pageButtons = [this.topButtons.addButton, this.topButtons.editButton, this.topButtons.deleteButton, { type: 'seprator' }, this.topButtons.operationsButton, this.topButtons.systemSalaryItemButton]
			this.getData()
			this.prepareWindow(this.$t(`nav.trans.salary-items`), pageButtons)
			if (!this.settings.isMultiSelect) {
				this.tableOption.rowSelection.mode = 'singleRow'
				// this.tableOption.columnDefs[0].headerCheckboxSelection = false
				// this.tableOption.columnDefs[0].checkboxSelection = false
			}
		},
		methods: {
			showDeleteDialog() {
				if (!this.selectedRow) {
					return
				}
				dialog({
					title: this.$t('salary.item.m.delete.title'),
					body: this.$t('salary.item.m.delete.want-to-delete',
						{
							code: this.selectedRow.code,
							name: `${this.selectedRow.name}`,
						}),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: () => {
								this.deleteItem()
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: () => { },
						},
					],
				})
			},
			deleteItem() {
				var wait = this.$wait(this.grandParent)
				const { code, name } = this.selectedRow
				post(Endpoints.getUrl('salaryItem.delete'), {
					salaryItemId: this.selectedRow.id,
				})
					.then((result: IResponse<any>) => {
						wait.end()
						this.$toast(this.$t('salary.item.m.delete.success-body', {
							code,
							name: `${name}`,
						}), { type: TYPE.SUCCESS })
						this.getData()
					})
					.catch(() => {
						wait.end()
					})
			},
			handlerBtnSelect() {
				if (!this.settings.isMultiSelect && this.settings.isSelectionMode && this.selectedRow) {
					this.resolve(this.selectedRow)
					return
				}
				if ((this.settings.isSelectionMode && !this.selectedRows.length) || (!this.settings.isSelectionMode && isEmpty(this.selectedRow)))
					return this.$toast(this.$t('document.m.select-row'))
				this.resolve(this.settings.isSelectionMode ? this.selectedRows : this.selectedRow)
			},
			print_dataSources() {
				// let clonedLocalData = _.cloneDeep(this.document)
				// clonedLocalData.factorDetails = this.$refs.table.getTableData().data
				// return [
				// 	{
				// 		name: 'Document',
				// 		data: clonedLocalData,
				// 		translatedDataSetName: this.$t('nav.document'),
				// 		translatePrefix: 'document.f',
				// 		converter: {
				// 			type: PrintDataConvertTypes.MAPPER,
				// 			settings: {
				// 				code: 'code',
				// 				attachNumber: 'attachNumber',
				// 				codeInReports: 'codeInReports',
				// 				codeInSybsystem: 'codeInSybsystem',
				// 				codeInDay: 'codeInDay',
				// 				date: (item) => new Date(item).toLocaleDateString('fa-IR'),
				// 				system: (item, row) => this.$t(`badges.system.${item.toLowerCase()}`),
				// 				sumCredits: 'sumCredits',
				// 				sumDebits: 'sumDebits',
				// 				user: 'user.userName',
				// 				details: {}
				// 			}
				// 		},
				// 	},
				// ]
			},
			getData(requestOptions: any = null, selectRowCode: string | null = null) {
				var wait = this.$wait(this.$el)
				post(Endpoints.getUrl('salaryItem.list'), {}, (result: IResponseList<ConvSalaryItem>) => {
					let data = result.data.items

					if (this.settings.filterByTypes.length)
						data = data.filter((x: ConvSalaryItem) => this.settings.filterByTypes.includes(x.type))

					if (this.settings.filterByfillTypes.length)
						data = data.filter((x: ConvSalaryItem) => this.settings.filterByfillTypes.includes(x.fillType))

					if (this.settings.filterByActionTypes.length)
						data = data.filter((x: ConvSalaryItem) => this.settings.filterByActionTypes.includes(x.actionType))

					if (this.settings.excludeByIds.length)
						data = data.filter((x: ConvSalaryItem) => !this.settings.excludeByIds.includes(x.id))

					if (this.grandParentType() === 'modal' && this.settings.excludeDisabledItems)
						data = data.filter((x: ConvSalaryItem) => x.isActive === true)

					this.items = data

					if (this.items && this.items.length)
						this.topButtons.printButton.disabled = false

					this.selectedRow = this.items.find((x: any) => x.code === selectRowCode)
					wait.end()
				}, requestOptions)
			},
			showItem(row: ConvSalaryItem | null, insertNew: boolean = false) {
				if (!insertNew && !row && !this.selectedRow) {
					this.$toast(this.$t('document.m.select-row'), { type: TYPE.INFO })
					return
				}

				if (this.isModal) {
					this.resolve(this.settings.isSelectionMode ? [row] : row)
				} else {
					this.showModal({
						component: modifyItem,
						data: insertNew ? null : row || this.selectedRow
					}).then((res: any) => {
						this.getData({}, res.data)
					}).catch(() => { })
				}
			},
			changeFormModeToSelection() {
				if (this.settings.isSelectionMode) {
					this.tableOption.multiselection = true
					this.tableOption.checkboxesEnabled = true
					this.tableOption.rowSelection = {
						mode: 'multiRow',
						checkboxes: true,
						headerCheckbox: true
					}
				}
			},
			showSystemSalaryItems(isCurrentPeriod: boolean = true) {
				this.showModal({
					component: SystemSalaryItemList,
					options: {
						currentItems: this.items
					}
				}).then(() => {
					this.getData()
				}).catch(() => {

				})

			},
			showUsageModal(isCurrentPeriod: boolean = true) {
				this.showModal({
					component: SalaryItemContractsUsage,
					options: {
						salaryItemId: this.selectedRow.id,
						isCurrentPeriod: isCurrentPeriod
					}
				}).then(() => { }).catch(() => {

				})

			},
			showDependencyModal() {
				this.showModal({
					component: SalaryItemDependency,
					options: {
						salaryItemId: this.selectedRow.id,
					}
				}).then(() => { }).catch(() => {

				})
			}
		}
	})
</script>

<style scoped></style>